import { render } from "./App.vue?vue&type=template&id=6f0c4fbc"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "/home/aria/Documents/gawean/pt.ksi/program/vue/ksi_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__